/** Ajuda — Financeiro: caixa, despesas, formas de pagamento, estoque e compras. */
export const financeiro = {
  id: "financeiro",
  titulo: "Financeiro, caixa e estoque",
  icone: "DollarSign",
  intro: "Caixa do dia, despesas, formas de pagamento e o controle de estoque com custo real dos pratos.",
  topicos: [
    {
      pergunta: "Como funciona o Caixa?",
      resposta: "Em Financeiro → Caixa você ABRE o caixa informando o fundo de troco. Durante o dia, as vendas entram automaticamente por forma de pagamento; SANGRIA retira dinheiro (ex.: pagar entregador) e SUPRIMENTO adiciona. No FECHAMENTO, você confere o valor físico contra o esperado — a diferença fica registrada no histórico do caixa.",
      videos: ["KZKqmUp9OZE"],
    },
    {
      pergunta: "Como lanço despesas e contas a pagar?",
      resposta: "Financeiro → Despesas: lance a despesa com categoria, valor, vencimento e status (paga/pendente). Entregas feitas por parceiro integrado viram despesa PAGA automaticamente, já classificadas. Os relatórios cruzam despesas com vendas pra mostrar a margem do período.",
      videos: ["KCJ0b6OnBY0"],
    },
    {
      pergunta: "Quais formas de pagamento posso aceitar?",
      resposta: "Em Financeiro → Formas de Pagamento você ativa dinheiro (com pergunta de troco), cartão na entrega, PIX manual e PIX ONLINE (via Mercado Pago, com QR gerado no checkout e confirmação automática). Dá pra escolher quais formas aparecem em cada canal.",
      videos: ["UMu-14uVjDc"],
    },
    {
      pergunta: "Como configuro o PIX online?",
      resposta: "Conecte sua conta Mercado Pago em Financeiro → Formas de Pagamento. O cliente paga na finalização do pedido pelo QR/copia-e-cola, e a confirmação chega sozinha — o pedido mostra pagamento aprovado sem ninguém conferir comprovante. Importante: a Cleo nunca envia chave PIX no WhatsApp; pagamento online acontece só no cardápio.",
    },
    {
      pergunta: "Como funciona o Estoque?",
      resposta: "Em Estoque você cadastra os INSUMOS (ingredientes e embalagens) com unidade e custo. Na FICHA TÉCNICA de cada produto, informa quanto de cada insumo o prato usa — assim o sistema calcula o CMV (custo real) e a margem de cada item do cardápio, e dá baixa no estoque conforme as vendas.",
      videos: ["sVcHNjOTKGg", "qHaRs-ihD5Q", "C4YX4dvGiK4"],
    },
    {
      pergunta: "Pra que serve a tela de Compras?",
      resposta: "Registra as notas de compra de insumos: fornecedor, itens, quantidades e preços. Ao lançar a compra, o estoque sobe e o CUSTO do insumo é atualizado — e o CMV de todos os pratos que usam aquele insumo recalcula em cascata. O histórico mostra a variação de preço por fornecedor.",
      videos: ["g4fxXZZCsV0"],
    },
    {
      pergunta: "Onde acompanho o resultado da loja?",
      resposta: "Visão Geral traz o dia e o mês em tempo real (faturamento, pedidos, ticket médio, previsão do dia). Os Relatórios detalham por período: Vendas (faturamento e formas de pagamento), Produtos e Categorias (o que mais vende), Módulos (qual canal vende mais), Pagamentos, Estoque e Ofertas. Todos exportam os dados do período filtrado.",
      videos: ["-T3587U38EA", "a5l6SbsaHVg", "4h-mVDDE5qU", "G9BQtlOWd4M", "az0aE_WpYmw", "5-CJOpMxnv0", "CT4ChZ7Rvkg"],
    },
    {
      pergunta: "Qual a diferença entre o DRE e o Fluxo de Caixa?",
      resposta: "O DRE (Financeiro › DRE) responde \"deu lucro?\": vendas do período menos descontos, taxas de cartão e marketplace, compras e cada despesa lançada. O Fluxo de Caixa (Financeiro › Fluxo de Caixa) responde \"vai ter dinheiro na conta?\": quando cada venda cai na conta, pelo prazo de cada forma de pagamento, e quando cada conta vence. Os dois usam a taxa e o prazo configurados em Financeiro › Formas de Pagamento.",
      videos: ["kV2nkuBz2FI", "cK-J0aWQGPY"],
    },
  ],
};
